module.exports = __webpack_public_path__ + "img/profile.cbb4f22b.png";